import { isEmbeddedRoute, isPreviewRoute } from "~/utils/route_helpers";

export class Resizer {
  private static instance: Resizer;
  private resizeObserver: ResizeObserver | null;

  private constructor() {
    this.resizeObserver = null;
  }

  static getInstance(): Resizer {
    if (!Resizer.instance) {
      Resizer.instance = new Resizer();
    }
    return Resizer.instance;
  }

  init() {
    if (!this.resizableRoute() || this.resizeObserver) return;

    window.addEventListener("message", this.onMessage);

    this.resizeObserver = new ResizeObserver(() => {
      this.postScrollHeight();
    });
    this.resizeObserver.observe(document.body);
  }

  postHeight() {
    if (!this.resizableRoute()) return;

    this.postScrollHeight();
  }

  cleanup() {
    if (!this.resizableRoute()) return;

    window.removeEventListener("message", this.onMessage);
    this.resizeObserver?.disconnect();
    this.resizeObserver = null;
  }

  private resizableRoute() {
    return (
      isEmbeddedRoute(window?.location.pathname || "") ||
      isPreviewRoute(window?.location.pathname || "")
    );
  }

  private onMessage = (e: MessageEvent) => {
    if (e.data == "resize") {
      this.postScrollHeight();
    }
  };

  private postScrollHeight = () => {
    window.parent.postMessage(document.body.scrollHeight, "*");
  };
}
